import { Component, computed, input, output } from '@angular/core';
import { PortalTimeAgoPipe } from '@app/shared/pipes/portal-time-ago.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { currentLanguage } from '@app/utils/translate';
import { MyPortalNotificationViewModel } from '@business/notification/models/my-portal-notifications-view-model';
import { getTranslationsByKey } from '@business/notification/models/portal-notification-helpers';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'portal-my-notification-item-header',
  standalone: true,
  imports: [PortalTimeAgoPipe, SharedModule, TranslatePipe],
  templateUrl: './my-notification-item-header.component.html',
  styles: `
    :host {
      display: flex;
      width: 100%;
    }
  `,
})
export class MyNotificationItemHeaderComponent {
  busy = input.required<boolean>();
  busyWith = input.required<number | string | null>();
  canDelete = input<boolean>(true);
  notification = input.required<MyPortalNotificationViewModel>();
  delete = output();
  markAsSeen = output();

  language = currentLanguage();
  title = computed(() => getTranslationsByKey(this.notification().titles, this.language()).title);
  content = computed(() => getTranslationsByKey(this.notification().translations, this.language()));
}
